import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';
import { GetPicsResponse } from './models/pics.model';

@Injectable({
	providedIn: 'root',
})
export class PicsRequester extends DcBaseRequester<GetPicsResponse> {
	protected resource: string;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('PICTOGRAMMES');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = `${this.elementsListUrl}`;
	}

	public getAvailablePics(
		recentlyUploaded = new Set<string>(),
		refresh = false
	): Observable<GetPicsResponse> {
		const url = this.urlService.generateUrl(this.resource, {}, {});
		const cachingPolicy = refresh
			? CachePolicyEntity.build({
					policy: CachePolicy.NetworkAndCache,
					maxAgeInSeconds: 60,
					isCacheable: true,
			  })
			: CachePolicyEntity.build({
					policy: CachePolicy.CacheOnly,
					maxAgeInSeconds: 60,
					isCacheable: true,
			  });
		return this.get<GetPicsResponse>(url, cachingPolicy);
	}
}
